export enum ConnectorDynamicsCpmStatus {
  Available = 2,
  Removed = 3,
  OutOfOrder = 4,
  Blocked = 5
}
